<template>
  <div style="clear: both">
    <template v-if="readonly && modelValue && !forceEdit">
      <v-text-field
        :label="$t('Valid_Until_Date')"
        :model-value="$filters.DateFilter(modelValue)"
        readonly
        variant="underlined"
        :rules="rules.startDateRules"
        dense
        density="comfortable"
      ></v-text-field>
    </template>

    <template v-if="!readonly || forceEdit">
      <v-menu
        v-model="formSettings.validUntilDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ props }">
          <v-text-field
            :model-value="calculatedValue"
            :label="$t('Valid_Until_Date')"
            prepend-icon="mdi-calendar"
            readonly
            variant="underlined"
            v-bind="props"
            dense
            density="comfortable"
            name="validUntilDate"
            :rules="rules.validUntilDateRules"
            :placeholder="`${$t('Rule_Required_ValidUntilDate')}`"
          ></v-text-field>
        </template>
        <v-date-picker
          :model-value="selectedDate"
          hide-header
          no-title
          :min="formSettings.minStartDate"
          :max="maxDateComputed360"
          :readonly="readonly"
          v-on:update:model-value="updateValue"
        ></v-date-picker>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { ChangeTypes } from '@/common/types'
import dateMixins from '@/mixins/dateMixins'
import moment from 'moment'
export default {
  name: 'ValidUntiDateField',
  emits: ['update:modelValue'],
  mixins: [dateMixins],
  data() {
    let self = this
    return {
      formSettings: {
        validUntilDateMenu: false,
        minStartDate: new Date(new Date().setDate(new Date().getDate())).toISOString()
      },
      picker: null,
      error: false,
      rules: {
        validUntilDateRules: [
          (v) => !!v || ' ',
          (v) => (v && self.dateEqualOrIsBefore(this.selectedDate, moment())) || this.$t('Date_Not_In_Past')
        ]
      }
    }
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    changeType: {
      type: Object
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    forceEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dateEqualOrIsBefore(fromDate, toDate) {
      return this.changeType.key === ChangeTypes.TEMPORARY.toString() && moment(fromDate).isSameOrAfter(toDate, 'day')
    },

    updateValue: function (value) {
      this.formSettings.validUntilDateMenu = false
      let time = '23:59:59.000'
      // this.$emit('input', moment(value + ' ' + time).format())
      const dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())
      // this.$emit('update:modelValue', dateString)
      this.$emit('update:modelValue', moment(dateString + ' ' + time).format())
    },
    getTimeLeftPad: function(number){
      // console.log(`number ${number}`)
      if(number.length < 2){
        return '0' + number
      }
      return number
    }    
  },
  computed: {
    calculatedValue() {
      return this.formattedDate ? this.$filters.DateFilter(this.formattedDate) : ''
    },
    readonly: function () {
      if (this.forceReadonly) {
        return true
      }
      switch (this.mocFormStatus) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value)
          ) {
            return true
          }
          return false
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.OWNER].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        default:
          return true
      }
      return true
    },

    selectedDate: function () {
      // return this.modelValue
      if (!this.modelValue) return null
      // return this.formatDate(this.modelValue)
      // return this.formatDate(this.modelValue)
      // return this.modelValue
      return new Date(this.modelValue)
    }
  }
}
</script>

<style scoped></style>
